import React from 'react';
import './AppSkeletons.css';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`sk-block ${className}`.trim()} aria-hidden="true" />
);

export const LandingSectionSkeleton = ({ variant = 'recent' }) => {
  const isCategories = variant === 'categories';

  return (
    <section className={`sk-section ${isCategories ? 'sk-section-categories' : 'sk-section-recent'}`} aria-hidden="true">
      <div className="sk-section-header">
        <SkeletonBlock className="sk-title" />
        <SkeletonBlock className="sk-link" />
      </div>
      <div className="sk-landing-row">
        {Array.from({ length: 6 }).map((_, idx) => (
          <div className="sk-mini-card" key={`${variant}-${idx}`}>
            <SkeletonBlock className={`sk-mini-media ${isCategories ? 'sk-mini-media-icon' : ''}`} />
            <SkeletonBlock className="sk-mini-line" />
          </div>
        ))}
      </div>
    </section>
  );
};

export const ProductTileSkeleton = () => (
  <div className="sk-product-tile" aria-hidden="true">
    <SkeletonBlock className="sk-product-image" />
    <div className="sk-product-lines">
      <SkeletonBlock className="sk-line-lg" />
      <SkeletonBlock className="sk-line-md" />
    </div>
    <div className="sk-chip-row">
      <SkeletonBlock className="sk-chip" />
      <SkeletonBlock className="sk-chip" />
      <SkeletonBlock className="sk-chip sk-chip-short" />
    </div>
    <SkeletonBlock className="sk-price" />
    <div className="sk-actions">
      <SkeletonBlock className="sk-stepper" />
      <SkeletonBlock className="sk-btn" />
    </div>
  </div>
);

export const ProductGridSkeleton = () => (
  <div className="product-grid-container sk-grid-wrap" aria-hidden="true">
    <div className="product-grid-layout">
      <aside className="product-sidebar">
        <SkeletonBlock className="sk-sidebar-title" />
        <div className="sk-sidebar-card">
          {Array.from({ length: 9 }).map((_, idx) => (
            <SkeletonBlock className="sk-sidebar-line" key={`cat-${idx}`} />
          ))}
        </div>
      </aside>
      <section className="product-content-area">
        <div className="sk-toolbar">
          <SkeletonBlock className="sk-toolbar-left" />
          <div className="sk-toolbar-right">
            <SkeletonBlock className="sk-toolbar-pill" />
            <SkeletonBlock className="sk-toolbar-pill" />
          </div>
        </div>
        <div className="product-grid sk-product-grid">
          {Array.from({ length: 9 }).map((_, idx) => (
            <ProductTileSkeleton key={`tile-${idx}`} />
          ))}
        </div>
      </section>
    </div>
  </div>
);

export const ProductDetailSkeleton = () => (
  <div className="pd-container sk-pdp" aria-hidden="true">
    <div className="sk-breadcrumbs">
      <SkeletonBlock className="sk-crumb" />
      <SkeletonBlock className="sk-crumb" />
      <SkeletonBlock className="sk-crumb sk-crumb-wide" />
    </div>

    <div className="pd-grid">
      <div className="pd-image-card sk-card">
        <SkeletonBlock className="sk-pdp-image" />
        <div className="sk-dot-row">
          <SkeletonBlock className="sk-dot" />
          <SkeletonBlock className="sk-dot" />
          <SkeletonBlock className="sk-dot" />
        </div>
      </div>

      <div className="pd-info">
        <SkeletonBlock className="sk-brand" />
        <SkeletonBlock className="sk-pdp-title" />
        <SkeletonBlock className="sk-pdp-title sk-pdp-title-short" />
        <div className="sk-best-card">
          <SkeletonBlock className="sk-best-label" />
          <SkeletonBlock className="sk-best-price" />
          <SkeletonBlock className="sk-best-unit" />
        </div>
        <div className="sk-actions-card">
          <SkeletonBlock className="sk-stepper" />
          <SkeletonBlock className="sk-btn" />
        </div>
      </div>
    </div>

    <div className="sk-comp-title-wrap">
      <SkeletonBlock className="sk-comp-title" />
    </div>
    <div className="sk-comp-list">
      {Array.from({ length: 3 }).map((_, idx) => (
        <div className="sk-comp-card" key={`cmp-${idx}`}>
          <div className="sk-comp-left">
            <SkeletonBlock className="sk-comp-logo" />
            <div className="sk-comp-lines">
              <SkeletonBlock className="sk-line-md" />
              <SkeletonBlock className="sk-line-sm" />
            </div>
          </div>
          <SkeletonBlock className="sk-comp-price" />
        </div>
      ))}
    </div>
  </div>
);
